export default __webpack_public_path__ + "static/media/gallery_07.7665bb3b.jpg";